var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 907.6 801.2",
    style: {
      enableBackground: "new 0 0 907.6 801.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#01447A;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M787.6,111H624.3C621,54.8,574.4,10.2,517.5,10.2H391c-56.9,0-103.5,44.7-106.9,100.8H115.7 C55.9,111,7.5,159.4,7.5,219.2v466.4c0,59.8,48.5,108.3,108.3,108.3h671.8c59.8,0,108.3-48.5,108.3-108.3V219.2 C895.8,159.4,847.4,111,787.6,111L787.6,111z M391,60.1h126.5c29.4,0,53.6,22.3,56.8,50.8H334.2C337.4,82.4,361.6,60.1,391,60.1 L391,60.1z M654.1,321.6L578,392.8l68.6,229.1l-38.4,38.4c-4.2,4.2-11,4.2-15.2,0L490.7,474.5l-94,92.7l15,73.1l-24,23.9 c-3.2,3.2-8.3,3.2-11.5,0L240.8,528.8c-3.2-3.2-3.2-8.3,0-11.5l23.9-24l71.7,14.6l92.8-94.4L244.8,312.1c-4.2-4.2-4.2-11,0-15.2 l38.4-38.4l227.5,68.1l71.7-76.7c20.9-21,54-21.9,73.8-2.1C676,267.6,675.1,300.7,654.1,321.6L654.1,321.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPack);
export default __webpack_public_path__ + "static/media/pack.f54168b0ac36dc8ec2a6f6e450bf9f18.svg";
export { ForwardRef as ReactComponent };